import * as React from 'react';
import Moment from 'moment';
import { model, TerminalCommunicationService } from '@fresche/terminal-lib';

interface TextDisplayProps {
  input: any;
  formData: any;
  dropdownValue?: any;
}

/*
function replyToBackend(newFormData: any): void {
  // ... terminal lib need a refresh of its model
  model.next({
    data: newFormData
  });
  this.terminal.reply();
}
*/

function setActiveTab(e) {
  console.log(e.target);
}

function TextDisplay(props: TextDisplayProps) {
  const label = props.input?.label;
  const header1 = props.input?.header1;
  const isActionOnSelect = props.input?.actionOnFieldSelect;
  let value = props.formData['fields'][props.input.field];

  if(typeof value == "string"){
    if(value.indexOf("-") != -1){
      if(value.length == 10 && value.indexOf("-") == 4 && Moment(value, "YYYY-MM-DD", true).isValid()){
        const date = Moment(value);
        value = date.format("MM/DD/YYYY");
      }
    }
  }

  if (props.input?.type == "dropdown" && props.dropdownValue != null) {
    props.dropdownValue.forEach(e => {
      if (e?.value === props.formData['fields'][props.input.field]) {
        value = e?.label;
      }
    });
  }

  const terminal = new TerminalCommunicationService();

  const replyToBackend = (newFormData: any) => {
    console.log(newFormData);
    if (props.input.field === "dtl.wrkFormattedPharmacyName" &&
        newFormData.nextScreen === "phdPharmacyNetworkDtl/rcphd004AddPharNetWnd" &&
        newFormData.fields["dtl.phaPharmacyId"] != "") {
      const mediatorId = newFormData.mediatorId;
      const selectedPlans = [{ phaPharmacyId: newFormData.fields["dtl.phaPharmacyId"] }];
      const jumpParams = { "mediatorId": mediatorId, "selectedPlans": selectedPlans, "returnProgramCode": "RCPHD004" };
      window.parent.postMessage(
            {
                message: "new-navigate-to-ai-program",
                programCode: "RCPHA026",
                parameters: jumpParams
            }, '*')
      return;
    }
    newFormData['cmdKey'] = '10';
    newFormData['cursorField'] = props.input.field;
    // ... terminal lib need a refresh of its model
    model.next({
      data: newFormData
    });
    console.log("Call backend");
    terminal.reply();
  }
  
  

  return (
    <div className="display-val">
      <div>{label !== "" && value === undefined ? (
        <div><strong>{label}</strong></div>
      ): label !== "" ? (
        <div><strong>{label}</strong>:&nbsp;{value}</div>
      ): header1 !== "" ? (
        <div><strong>{header1}</strong>:&nbsp;{value}</div>
      ):
      <div>{isActionOnSelect ? (
        <a onClick={() => replyToBackend(props.formData)}><div>{value}</div></a>
      ):
          <div>{value}</div>
        }
        </div>
      }


      </div>
    </div>
  )}

  function selectProgram(): any {
  }

export default TextDisplay;
